"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enL18n = {
    write: 'Write',
    preview: 'Preview'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mde/lib/js/l18n/react-mde.en.js
// module id = 528
// module chunks = 2